<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
        <el-form-item label="证件类型" prop="idType">
          <el-select v-model="ruleForm.idType" placeholder="">
            <el-option v-for="item in idTypeList" :key="item.id" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="style" label="身份证人像面照片" prop="uboInfoIdCardCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.uboInfoIdCardCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.uboInfoIdCardCopy"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return uboInfoIdCardCopySuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="身份证国徽面照片" prop="uboInfoIdCardNational">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.uboInfoIdCardNational.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.uboInfoIdCardNational"
                :file-list="nationalList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove1"
                :on-success="
                  (response, file, fileList) => {
                    return uboInfoIdCardNationalSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="身份证姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="idNumber">
          <el-input v-model="ruleForm.idNumber" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" prop="type" label="证件有效期类型">
          <div>
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="0">固定有效期</el-radio>
              <el-radio :label="1">长期有效</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="idPeriodBegin">
          <el-date-picker
            v-model="ruleForm.idPeriodBegin"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === 0" label="有效期限结束日期" prop="idPeriodEnd">
          <el-date-picker
            v-model="ruleForm.idPeriodEnd"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      nationalList: [],
      ruleForm: {
        idType: 'IDENTIFICATION_TYPE_IDCARD',
        uboInfoIdCardCopy: [],
        uboInfoIdCardNational: [],
        name: '',
        idNumber: '',
        idPeriodBegin: '',
        idPeriodEnd: '',
        type: 0,
      },
      rules: {
        type: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        idType: [{ required: true, message: '请选择证件类型', trigger: ['blur', 'change'] }],
        uboInfoIdCardCopy: [{ required: true, message: '请上传人像面照片', trigger: ['blur', 'change'] }],
        uboInfoIdCardNational: [{ required: true, message: '请上传国徽面照片', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入受益人姓名', trigger: ['blur', 'change'] }],
        idNumber: [{ required: true, message: '请输入证件号码', trigger: ['blur', 'change'] }],
        idPeriodBegin: [{ required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change'] }],
        idPeriodEnd: [{ required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change'] }],
      },
      idTypeList: [
        {
          id: 0,
          name: '中国大陆居民-身份证',
          value: 'IDENTIFICATION_TYPE_IDCARD',
        },
        {
          id: 1,
          name: '中国香港居民-来往内地通行证',
          value: 'IDENTIFICATION_TYPE_HONGKONG_PASSPORT',
        },
        {
          id: 2,
          name: '中国澳门居民-来往内地通行证',
          value: 'IDENTIFICATION_TYPE_MACAO_PASSPORT',
        },
        {
          id: 3,
          name: '中国台湾居民-来往大陆通行证',
          value: 'IDENTIFICATION_TYPE_TAIWAN_PASSPORT',
        },
        {
          id: 4,
          name: '其他国家或地区居民-护照',
          value: 'IDENTIFICATION_TYPE_OVERSEA_PASSPORT',
        },
      ],
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = JSON.parse(JSON.stringify(data.subjectDataVO));
        let uboInfoIdCardCopyList = data.subjectDataVO.uboInfoIdCardCopy.split(',');
        let uboInfoIdCardNationalList = data.subjectDataVO.uboInfoIdCardNational.split(',');
        this.imgList = uboInfoIdCardCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
        this.nationalList = uboInfoIdCardNationalList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    uboInfoIdCardCopySuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.uboInfoIdCardCopy = file.response.data.url;
      console.log(this.ruleForm.uboInfoIdCardCopy);
    },
    uboInfoIdCardNationalSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.uboInfoIdCardNational = file.response.data.url;
      console.log(this.ruleForm.uboInfoIdCardNational);
    },
    handleRemove() {
      this.ruleForm.uboInfoIdCardCopy = [];
    },
    handleRemove1() {
      this.ruleForm.uboInfoIdCardNational = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
